import React from 'react';
import { Zap, Sparkles } from 'lucide-react';
import './LoadingOverlay.css';

const LoadingOverlay = ({ 
  title = "AI Earnings Assistant",
  message = "Initializing your analytics dashboard...",
  show = false 
}) => {
  if (!show) return null;

  return (
    <div className="loading-overlay">
      <div className="loading-content">
        <div className="loading-icon-container">
          <div className="loading-icon">
            <Zap className="w-10 h-10 text-white animate-bounce" />
          </div>
          <div className="loading-icon-dot">
            <Sparkles className="w-3 h-3 text-white" />
          </div>
        </div>
        
        <div className="loading-text">
          <h2 className="loading-title">
            {title}
          </h2>
          <p className="loading-message">
            {message}
          </p>
        </div>
        
        <div className="loading-dots">
          <div className="loading-dot"></div>
          <div className="loading-dot" style={{ animationDelay: '0.1s' }}></div>
          <div className="loading-dot" style={{ animationDelay: '0.2s' }}></div>
        </div>
      </div>
    </div>
  );
};

export default LoadingOverlay;
